/** @jsx jsx */
import { jsx } from "theme-ui"
import logo from '../images/banl-logo-reverse.png'
import Heading from './heading'
import Link from './link'
import Nav from './nav'

export default function HeaderNav({light}: {light?: boolean}) {
    return <div sx={{ 
        display: ['block', 'flex'], 
        color: 'primary',
        justifyContent: 'space-between', 
        background: 'secondary',
        alignItems: 'center',
        paddingX: 5,
        paddingY: 3,
        padding: '12px 20px',
        borderBottom: '3px solid #375FAD',
    }}>
        <div style={{display: 'flex', alignItems: 'center',}}>
            <Link to='/'><img src={logo} alt='BANL logo' width={40} style={{display: 'block', marginRight: '16px'}} /></Link>
            <Heading weightNormal><Link to='/' ssx={{fontSize: 5, color: 'primary',}}>Explore Art NL</Link></Heading>
        </div>

        <Nav linkSx={{color: 'primary'}} inline />
    </div>
}